import { Div, Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { useState } from 'src/hooks'
import { Icon as DSIcon } from 'src/design_system/atoms/icons/components/Icon'

interface Props {
  copyText: string
  isCompact?: boolean
}

export const Clipboard: React.FC<Props> = props => {
  const { copyText, isCompact = false } = props

  const [isCopied, setIsCopied] = useState(false)

  const styles = {
    input: {
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: isCompact ? '.85rem' : '1rem',
      fontWeight: isCompact ? 600 : 700,
      color: '#000',
      padding: isCompact ? '0' : '0 0 0 1.5rem',
      margin: '0',
      fontFamily: 'Montserrat, sans-serif',
      maxWidth: '8.5rem',
      letterSpacing: isCompact ? '.01em' : 'normal',
    },
  }

  const iconName = isCopied ? 'check' : 'copy'
  const iconColor = isCopied ? '#16a34a' : '#111827'

  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  const handleCopy = () => {
    copyTextToClipboard(copyText)
      // eslint-disable-next-line
      .then(() => {
        setIsCopied(true)
        setTimeout(() => {
          setIsCopied(false)
        }, 1200)
      })
      // eslint-disable-next-line
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <Div
      display="flex"
      backgroundColor={isCompact ? 'transparent' : '#daf6ff'}
      inset={isCompact ? '0px' : { vertical: 'x_75', right: 'x_75' }}
      borderRadius={isCompact ? 'medium' : 'large'}
      alignItems="center"
      style={isCompact ? { columnGap: '6px' } : undefined}
    >
      {isCompact ? (
        <Text
          type="body"
          content={copyText}
          weight="bold"
          style={{
            fontSize: '.85rem',
            fontWeight: 600,
            letterSpacing: '.01em',
          }}
        />
      ) : (
        <input type="text" value={copyText} readOnly style={styles.input} />
      )}
      <Flex
        onClick={handleCopy}
        backgroundColor={isCompact ? 'transparent' : 'foreground'}
        borderRadius="medium"
        inset={
          isCompact
            ? { vertical: 'x_25', horizontal: 'x_25' }
            : { vertical: 'x_25', horizontal: isCopied ? 'x_75' : 'x1_5' }
        }
        cursor="pointer"
        alignItems="center"
        justifyContent="center"
      >
        {!isCompact && (
          <>
            <Text
              type="footnote"
              content={isCopied ? 'COPIED' : 'COPY'}
              color="primaryHeading"
              weight="extraBold"
              style={{ fontSize: '.563rem' }}
            />
            <Spacer orientation="horizontal" space="x_5" />
          </>
        )}
        <DSIcon name={iconName} size={12} color={iconColor} />
      </Flex>
    </Div>
  )
}
